module.exports = __webpack_public_path__ + "img/gpsReports.e1db421a.svg";